import { render, staticRenderFns } from "./CommonFile.vue?vue&type=template&id=549e3333&scoped=true&"
import script from "./CommonFile.vue?vue&type=script&lang=ts&"
export * from "./CommonFile.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFile.vue?vue&type=style&index=0&id=549e3333&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549e3333",
  null
  
)

export default component.exports